module.exports = __webpack_public_path__ + "img/zi.0e02706c.png";